import React, { useState } from "react";
import bgpattern from "assets/images/home-page-images/Rectangle2.png";
import bgpattern1 from "assets/images/home-page-images/image2.png";
import Search from "assets/images/pricing/Search.png";
import MDBox from "components/MDBox";
import Footer from "./components/footer.js";
import Header from "./components/header";
import MDTypography from "components/MDTypography/index.js";
import {
  TextField,
  InputAdornment,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Container,
} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import DemoRequestForm from "./components/DemoRequestForm.js";
import Rectangle73 from "assets/images/home-page-images/Landingcard.png";
import Blog2 from "assets/images/home-page-images/Blog2.png";
import Blog3 from "assets/images/home-page-images/Blog3.png";

import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Insight = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const cardList = [
    {
      image: Rectangle73,
      heading: "Restaurant Marketing",
      title: "10 AI Restaurant Marketing Strategies in 2025",
      description:
        "The marketing world moves fast, especially in the restaurant industry. New apps, social trends, and tech tools seem to appear every month.",
      date: "24th July, 2025",
      link: "/insightContent",
    },
    {
      image: Blog2,
      heading: "Latest",
      title: "AI in Restaurant Marketing: What You Need to Know",
      description: "Restaurant marketing has changed a lot over the past decade. Flyers, radio spots, and word-of-mouth still matter, but in 2026, artificial intelligence (AI).",
      date: "August 12, 2025",
      link: "/customer",
    },
    {
      image: Blog3,
      heading: "Trending",
      title: "Why Your Restaurant Needs an AI Review Assistant in 2026",
      description: "In 2026, your restaurant’s online reputation is crucial. A single review can influence many potential customers.",
      date: "August 13, 2025",
      link: "/operational",
    },
    // {
    //   image: "https://placehold.co/300x300?text=Coming+Soon",
    //   heading: "Latest",
    //   title: "Customer Experience",
    //   description: "Personalizing services with intelligent recommendations.",
    //   date: "July 24, 2025",
    // },
    // {
    //   image: "https://placehold.co/300x300?text=Coming+Soon",
    //   heading: "Trending",
    //   title: "Operational Efficiency",
    //   description: "Streamlining restaurant operations with automation.",
    //   date: "July 23, 2025",
    // },
    // {
    //   image: "https://placehold.co/300x300?text=Coming+Soon",
    //   heading: "Trending",
    //   title: "Operational Efficiency",
    //   description: "Streamlining restaurant operations with automation.",
    //   date: "July 23, 2025",
    // },
  ];

  const filteredCards = cardList.filter(
    (card) =>
      card.heading.toLowerCase().includes(searchTerm.toLowerCase()) ||
      card.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <MDBox
      sx={{
        width: "100%",
        maxWidth: {
          xs: "100%",
          md: "1580px",
          xl: "1920px",
        },
        mx: "auto",
        // px: 2,
      }}
    >
      <Helmet>
        <title> TavloAI Insights | Hospitality Trends & Growth Tips</title>
        <meta
          name="description"
          content=" Explore TavloAI’s blog for hospitality trends, AI marketing strategies, and growth insights to help businesses in hospitality and beyond thrive in a competitive market."
        />
        <meta name="keywords" content="Hospitality Trends" />
      </Helmet>

      <Header />
      <MDBox sx={{ width: "100%", margin: "auto" }}>
        <MDBox
          sx={{
            position: "relative",
            mt: { xs: 2, sm: 4, md: 16 },
            backgroundImage: `url(${bgpattern})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            height: { xs: "400px", sm: "600px", md: "600px" },
          }}
        >
          <MDBox
            sx={{
              position: "absolute",
              bottom: {
                xs: -10,
                sm: -10,
                md: -180,
              },
              left: 0,
              zIndex: 0,
              width: "100%",
            }}
          >
            <MDBox
              component="img"
              src={bgpattern1}
              alt="background"
              sx={{
                width: {
                  xs: "430px",
                  sm: "95%",
                  md: "100%",
                },

                height: {
                  xs: "171px",
                  sm: "657px",
                  md: "613px",
                },
              }}
            />

            {/* <img
              src={bgpattern1}
              alt="background pattern"
              style={{ width: "100%" }}
            /> */}
          </MDBox>

          <MDBox
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              flexDirection: "column",
              py: 8,
              px: 2,
            }}
          >
            <MDTypography
              sx={{
                fontWeight: 700,
                fontSize: { xs: "18px", md: "40px" },
                color: "#318BEC",
                fontFamily: "Poppins",
                lineHeight: 1.4,
              }}
            >
              Resources and Insights
            </MDTypography>
            <MDTypography
              sx={{
                fontWeight: 400,
                fontSize: { xs: "12px", sm: "16px", md: "16px" },
                color: "#000",
                width: { xs: "75%", sm: "auto", md: "auto" },
                maxWidth: "600px",
                mb: { xs: 2, sm: 3, md: 3 },
                fontFamily: "Poppins",
              }}
            >
              The Latest industry trends, technologies, and insightful resources
            </MDTypography>

            {/* Search Bar */}
            <MDBox
              sx={{
                width: { xs: "100%", sm: "50%", md: "50%" },
                margin: "auto",
              }}
            >
              <TextField
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{
                  width: { xs: "80%", sm: "50%", md: "51%" },
                  margin: "auto",
                  maxWidth: "500px",
                  backgroundColor: "#fff",
                  border: "1px solid #318BEC",
                  borderRadius: "15px",
                  boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "15px",
                    paddingLeft: "8px",
                    height: { xs: "27px", sm: "37px", md: "37px" },
                    "& input": {
                      padding: { xs: "0px", sm: "13px 0", md: "13px 0" },
                    },
                  },
                  "& input::placeholder": {
                    color: "gray",
                    opacity: 1,
                    fontSize: { xs: "11px", sm: "auto", md: "15px" },
                    lineHeight: { xs: "15px", sm: "auto", md: "auto" },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MDBox
                        component="img"
                        src={Search}
                        alt="Search"
                        sx={{
                          marginLeft: { xs: "7px", sm: "10px", md: "10px" },
                          width: { xs: "9px", sm: "15px", md: "15px" },
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </MDBox>
          </MDBox>
        </MDBox>
      </MDBox>

      <Container>
        <Grid
          container
          spacing={7}
          sx={{
            mt: { xs: -28, sm: -50, md: -50 },
            mb: { xs: 6, sm: 0, md: 0 },
            zIndex: 1,
          }}
        >
          {/* Left side: Cards */}
          <Grid item xs={12} md={12} sx={{ ml: { xs: 0, sm: -1, md: -1 } }}>
            <MDBox
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: {
                  xs: 2,
                  sm: 2,
                  md: 6,
                },
                justifyContent: "space-evenly",
                alignItems: "start",
              }}
            >
              {filteredCards.length > 0 ? (
                filteredCards.map((item, index) => (
                  <MDBox
                    key={index}
                    sx={{
                      width: {
                        xs: "47%",
                        sm: "48%",
                        md: "30%",
                      },
                    }}
                  >
                    <Card
                      sx={{
                        borderRadius: "10px",
                        boxShadow: "3px 6px 20px 3px #00000066",
                        overflow: "hidden",
                        height: "100%",
                      }}
                    >
                      <CardMedia
                        component="img"
                        image={item.image}
                        alt={item.title}
                        sx={{
                          m: { xs: "7px", sm: "auto", md: "17px" },
                          height: { xs: "166px", sm: "200px", md: "200px" },
                          borderRadius: "10px",
                        }}
                      />
                      <CardContent>
                        <MDTypography
                          variant="subtitle2"
                          sx={{
                            color: "#F47C00",
                            fontWeight: 600,
                            mb: { xs: 0.4, sm: 1, md: 1 },
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            fontFamily: "Poppins",
                            fontSize: { xs: "8px", sm: "12px", md: "12px" },
                          }}
                        >
                          {item.heading}
                        </MDTypography>
                        <NavLink to={item.link}>
                          <MDTypography
                            variant="subtitle2"
                            sx={{
                              color: "#000",
                              fontWeight: { xs: 700, sm: 600, md: 600 },
                              mb: 1,
                              gap: 1,
                              fontFamily: "Poppins",
                              fontSize: { xs: "10px", sm: "16px", md: "16px" },
                              height: { xs: "43px", sm: "45px", md: "50px" },
                            }}
                          >
                            {item.title}
                            <ArrowOutwardIcon
                              sx={{ fontSize: "40px", color: "#F47C00" }}
                            />
                          </MDTypography>
                        </NavLink>
                        {/* desktop  */}
                        <MDTypography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            display: { xs: "none", sm: "block", md: "block" },
                            mb: 2,
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            height: "80px",
                          }}
                        >
                          {item.description}
                        </MDTypography>
                        {/* mobile */}
                        <MDTypography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            display: { xs: "block", sm: "none", md: "none" },
                            fontFamily: "Poppins",
                            fontSize: { xs: "10px", sm: "12px", md: "12px" },
                            height: "20px",
                          }}
                        >
                          {item.description.slice(0, 20)}...
                        </MDTypography>
                        <MDTypography
                          variant="caption"
                          color="text.secondary"
                          sx={{
                            display: { xs: "none", sm: "block", md: "block" },
                            fontFamily: "Poppins",
                            fontSize: "12px",
                          }}
                        >
                          {item.date}
                        </MDTypography>
                      </CardContent>
                    </Card>
                  </MDBox>
                ))
              ) : (
                <MDBox>No results found.</MDBox>
              )}
            </MDBox>
          </Grid>

          {/* Right side: Tabs */}
          {/* <Grid item xs={12} md={3.5} sx={{ display:{xs:"none" , sm:"block", md:"block"}, pr: -6 }}>
            <MDBox
              sx={{
                width: "100%",
                m: "auto",
                borderRadius: "12px",
                backgroundColor: "#E5F6FF",
                px: 3,
                py: 2,
                boxShadow: " 4px 4px 15px 6px #0000001A",
              }}
            >
              <MDTypography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  mb: 1,
                  fontSize: "17px",
                  letterSpacing: 0.7,
                  textAlign: "center",
                  color: "#000",
                  fontFamily: "Poppins",
                  textTransform: "uppercase",
                }}
              >
                Key Tags
              </MDTypography>

              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={0}
                className="TabsBackGroundColor"
                sx={{
                  zIndex: 1,
                  position: "relative",
                  backgroundColor: "#E5F6FF",
                  borderColor: "divider",
                  "& .MuiTab-root": {
                    mb: 1.5,
                    alignItems: "flex-start",
                    textAlign: "left",
                  },
                }}
              >
                <Tab
                  label="Tab 1"
                  sx={{ zIndex: 0, py: 1.5, mb: 2, backgroundColor: "#fff" }}
                />
                <Tab
                  label="Tab 2"
                  sx={{ py: 1.5, mb: 2, backgroundColor: "#fff" }}
                />
                <Tab
                  label="Tab 3"
                  sx={{ py: 1.5, mb: 2, backgroundColor: "#fff" }}
                />
                <Tab
                  label="Tab 4"
                  sx={{ py: 1.5, mb: 2, backgroundColor: "#fff" }}
                />
                <Tab
                  label="Tab 5"
                  sx={{ py: 1.5, mb: 2, backgroundColor: "#fff" }}
                />
                <Tab
                  label="Tab 6"
                  sx={{ py: 1.5, mb: 2, backgroundColor: "#fff" }}
                />
                <Tab
                  label="Tab 7"
                  sx={{ py: 1.5, mb: 2, backgroundColor: "#fff" }}
                />
                <Tab
                  label="Tab 8"
                  sx={{ py: 1.5, mb: 2, backgroundColor: "#fff" }}
                />
                <Tab
                  label="Tab 9"
                  sx={{ py: 1.5, mb: 2, backgroundColor: "#fff" }}
                />
                <Tab
                  label="Tab 10"
                  sx={{ py: 1.5, mb: 2, backgroundColor: "#fff" }}
                />
              </Tabs>
            </MDBox>
          </Grid> */}
        </Grid>
      </Container>

      <Grid container>
        <Grid
          item
          lg={12}
          sx={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(49, 139, 236, 0.6) 100%)",
            py: { xs: 2, sm: 4, md: 12 },
            width: {
              xs: "100%",
              sm: "90%",
              md: "auto",
            },
            pb: {
              xs: 6,
              sm: 4,
              md: 6,
            },
          }}
        >
          <DemoRequestForm />
        </Grid>
      </Grid>
      <Footer />
    </MDBox>
  );
};

export default Insight;
